// ============================================
// Feature flags — tolerant parsing of Vite string env vars
// ============================================
//
// Vite exposes env vars as strings. A strict `=== 'true'` check silently
// disables a feature when someone sets `TRUE`/`True` in the Netlify UI (a
// common, easy-to-miss footgun — uppercase booleans look correct but fail the
// comparison). Parse case-insensitively so `true`/`TRUE`/`True ` all enable.

/** True when `value` is the string "true" (any case, trimmed). */
export function flagOn(value: string | undefined): boolean {
  return String(value ?? '').trim().toLowerCase() === 'true';
}

/** Cloud sync master switch — AccountMenu/OnboardingHint/SyncService all gate on this. */
export const cloudSyncEnabled = (): boolean =>
  flagOn(import.meta.env.VITE_FEATURE_CLOUD_SYNC);

/** Email-OTP sign-in (off until Resend SMTP + the {{ .Token }} template exist). */
export const emailOtpEnabled = (): boolean =>
  flagOn(import.meta.env.VITE_FEATURE_EMAIL_OTP);
